import { render, staticRenderFns } from "./DebtorAdjustmentRevenueTotals.vue?vue&type=template&id=6770cf83&scoped=true"
import script from "./DebtorAdjustmentRevenueTotals.vue?vue&type=script&lang=js"
export * from "./DebtorAdjustmentRevenueTotals.vue?vue&type=script&lang=js"
import style0 from "./DebtorAdjustmentRevenueTotals.vue?vue&type=style&index=0&id=6770cf83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770cf83",
  null
  
)

export default component.exports